"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMicrofrontend = exports.initMicrofrontend = void 0;
var shared_1 = require("@cian/peperrors/shared");
var browser_1 = require("@cian/config/browser");
var makeIdentityFromConfig_1 = require("../shared/microfrontend/identity/internal/makeIdentityFromConfig");
var registry_1 = require("./internal/registry/registry");
var BrowserMicrofrontend_1 = require("./microfrontend/internal/BrowserMicrofrontend");
var microfrontend;
/**
 * Создает и возвращает синглтон текущего микрофронтенда
 *
 * CDN-часть реестра должна быть уже загружена и инициализирована
 *
 * Identity создается из конфига. Должны быть доступны настройки:
 * * projectName
 * * pathApi
 * * version.commit
 *
 * @export
 * @return {*}
 */
function initMicrofrontend() {
    if (microfrontend) {
        return microfrontend;
    }
    var config = (0, browser_1.init)();
    var instance = (0, registry_1.getRegistry)().getMicrofrontend((0, makeIdentityFromConfig_1.makeIdentityFromConfig)(config));
    microfrontend = new BrowserMicrofrontend_1.BrowserMicrofrontend({ instance: instance });
    return microfrontend;
}
exports.initMicrofrontend = initMicrofrontend;
/**
 * Возвращает ранее созданный синглтон текущего микрофронтенда
 *
 * @export
 * @return {*}  {IBrowserMicrofrontend}
 */
function getMicrofrontend() {
    if (!microfrontend) {
        throw new shared_1.ConfigurationError({
            message: 'Microfrontend must be created before accessing it',
            domain: 'mf-registry.getMicrofrontend',
        });
    }
    return microfrontend;
}
exports.getMicrofrontend = getMicrofrontend;
//# sourceMappingURL=interface.js.map